import Marquee from 'react-fast-marquee';
import { CATEGORIES } from '../../data/site';

export const EditorialMarquee = () => (
  <div data-testid="category-marquee" className="overflow-hidden border-y border-line bg-surface py-6">
    <Marquee speed={28} gradient={false} pauseOnHover>
      {CATEGORIES.map((c, i) => (
        <span key={c.slug} className="mx-8 flex items-center gap-8">
          <span
            className={`whitespace-nowrap font-display text-3xl font-black uppercase tracking-tight sm:text-4xl ${
              i % 2 === 0 ? 'text-parchment/90' : 'text-outline'
            }`}
          >
            {c.name}
          </span>
          <span className="font-mono text-xl text-volt">//</span>
        </span>
      ))}
    </Marquee>
  </div>
);
